<template>
  <div class="studytour-wrap">
    <div class="studytour-banner" style=" background-image:url('https://jiemancang.oss-cn-beijing.aliyuncs.com/hongfanzhihui/youxue/banner.png')">
      <p>
        立足中国，放眼国际
        <br />
        在世界中留下寻访清洁前路的脚印
      </p>
    </div>
    <div class="studytour-content">
      <div class="studytour-box">
        <template v-for="(item,index) in travels">
        <div class="study-item">
          <div class="study-hd">
            <span class="year">{{item.year}}</span>
            {{item.cityName}}
          </div>
          <div class="study-bd">
            <swiper :options="swipers[index]" ref="mySwiper">
              <template v-for="img in item.imgs">
                <swiper-slide>
                  <img :src="img.imgUrl" width="400" height="400" />
                  <p class="txt">{{ img.description }}</p>
                </swiper-slide>
              </template>
            </swiper>
            <div :class="'swiper-button-next swp'+(index+1)+' qjico'"></div>
            <div :class="'swiper-button-prev swp'+(index+1)+' qjico'"></div>
          </div>
        </div>
        </template>
      </div>
    </div>
  </div>
</template>

<script>
import { swiper, swiperSlide } from 'vue-awesome-swiper';
require('swiper/dist/css/swiper.css');

export default {
  components: {
    swiper,
    swiperSlide,

  },
  data() {
    return {
      swipers:[],
      path: domain.apiUrl,
      travels: [],
      swiperOption1: {
        autoplay: {
        delay: 3000,
        },
      pagination: {
        el: '.swiper-pagination'
      },
        observer: true,
        observeParents: true,
        speed: 500,
        spaceBetween: 20,
         watchOverflow: true,
        navigation: {
          nextEl: '.swiper-button-next.swp1', //前进按钮的css选择器或HTML元素。
          prevEl: '.swiper-button-prev.swp1' ,//后退按钮的css选择器或HTML元素。
          disabledClass: "my-button-disabled", //前进后退按钮不可用时的类名。
          hiddenClass: "my-button-hidden" //按钮隐藏时的Class
        }
      },
    }
  },
  created() {
    this.travel();
  },
  methods: {
    travel: function() {
      this.$http.get(this.path + '/travel/travelIndex').then((response) => {
        if (response.status === 200) {
          this.travels = response.body;
          for (var i=1;i<=this.travels.length;i++){
            var obj = {};

   /*         var navigation = {
                nextEl: '.swiper-button-next.swp'+i, //前进按钮的css选择器或HTML元素。
                prevEl: '.swiper-button-prev.swp'+i, //后退按钮的css选择器或HTML元素。
                hiddenClass: 'my-button-hidden' //按钮隐藏时的Class
            } */
            var swiperOption_={
              slidesPerView: '4',
              notNextTick: true,
              observer: true,
              observeParents: true,
              speed: 500,
              spaceBetween: 20,
              navigation:{
                nextEl: '.swiper-button-next.swp'+i, //前进按钮的css选择器或HTML元素。
                prevEl: '.swiper-button-prev.swp'+i, //后退按钮的css选择器或HTML元素。
                hiddenClass: 'my-button-hidden' //按钮隐藏时的Class
            },
              breakpoints: {
                //当宽度大于等于320
                441: {
                  slidesPerView: 1.3,
                  spaceBetween: 10
                },
                //当宽度大于等于320
                769: {
                  slidesPerView: 2.5,
                  spaceBetween: 10
                },
                //当宽度大于等于769
                992: {
                  slidesPerView: 4,
                  spaceBetween: 20
                }
              }};
//            swiperOption_["navigation"] = navigation;
//            obj['swiperOption'+i] = swiperOption_
            this.swipers.push(swiperOption_);
          }
          console.log(this.swipers);
        }
      }, (response) => {
        this.$message.error("error")
      });
    },


  },
};
</script>

<style lang="scss">
@import '../assets/css/study.scss';
</style>



// WEBPACK FOOTER //
// src/components/studyAbroad.vue